export default __webpack_public_path__ + "static/1-395a0cd586759c7fecc939a43cdb500e.png";